import Skeleton from '@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const TabsSkeleton = () => {
  return (
    <Wrapper>
      <Skeleton variant='rectangular' width={110} height={32} />
      <Skeleton variant='rectangular' width={110} height={32} />
    </Wrapper>
  );
};
